module.exports = __webpack_public_path__ + "img/export.a4aa6681.svg";